import React from "react";
import ListeLots from "../../../componnents/ListeLots";

const Disponibilite = ({ lots, setDisplayedLot, displayedLot, openNewtab }) => {
  return (
    <section id="disponibilite" className="mt-70">
      <p className="semibold fs16 pink">Disponibilité</p>
      <ListeLots
        fav={false}
        lots={lots}
        setDisplayedLot={setDisplayedLot}
        openNewtab={openNewtab}
      />
    </section>
  );
};

export default Disponibilite;
